export default {
  // origin: 'https://seaart-publish.sc-ops-release.seaart.dev',
  origin: 'https://seaart-publish.sc-api-release.seaart.dev',
  // httpBaseUrl: 'https://seaart-gateway.sc-ops-release.seaart.dev/seaart_base',
  httpBaseUrl: 'https://seaart-gateway.sc-api-release.seaart.dev/seaart_base',
  httpPublishUrl: 'https://publish-gateway.sc-api-release.seaart.dev/publish',

  // 登录URI
  loginUri: 'https://seaart-publish.sc-api-release.seaart.dev/demo/login',
}
